<template>
  <div ref="wrapper" class="wrapper">
    <div ref="container" class="devices">
      <div v-if="screenshotDesktop" ref="desktop" class="device desktop">
        <img class="frame" width="930" height="1114" src="/img/imac.svg" alt>
        <div class="screen" ref="screen1">
          <div class="screen-content" ref="desktopContent">
            <img ref="desktopScreenshot" :src="desktopSrc">
          </div>
        </div>
      </div>
      <div v-if="screenshotTablet" ref="tablet" class="device tablet">
        <img class="frame" width="542" height="612" src="/img/ipad.svg" alt>
        <div class="screen" ref="screen2">
          <div class="screen-content">
            <img ref="tabletContent" :src="tabletSrc">
          </div>
        </div>
      </div>
      <div v-if="screenshotMobile" ref="mobile" class="device mobile">
        <img class="frame" width="247" height="404" src="/img/iphone.svg" alt>
        <div class="screen" ref="screen3">
          <div class="screen-content">
            <img ref="mobileContent" :src="mobileSrc">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax, TimelineMax } from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import { imageApi } from "@/api";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";

export default {
  props: {
    screenshotDesktop: String,
    screenshotTablet: String,
    screenshotMobile: String,
    screenshots: {
      type: Object
    }
  },
  data() {
    return {
      controller: null,
      wrapperW: 0,
      wrapperMaxW: 1240,
      windowW: 0,
      tls: null
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowSize.width;
    },
    desktopSrc() {
      return imageApi.getUrl(this.screenshotDesktop, {
        w: 930
      });
    },
    tabletSrc() {
      return imageApi.getUrl(this.screenshotTablet, {
        w: 540
      });
    },
    mobileSrc() {
      return imageApi.getUrl(this.screenshotMobile, {
        w: 480
      });
    }
  },
  methods: {
    initScroll() {
      this.controller = new ScrollMagic.Controller();

      const desktopAnimation = () => {
        // const desktopTl = new TimelineMax();
        // desktopTl.to(this.$refs.desktopScreenshot, 1, { y: "-100%" });

        // new ScrollMagic.Scene({
        //   triggerElement: this.$refs.desktopContent,
        //   triggerHook: 0.8,
        //   duration: "400%"
        // })
        //   .setTween(desktopTl)
        //   .addTo(this.controller);

        // const tabletTl = new TimelineMax();
        // TweenMax.from(this.$refs.tablet, 1, { y: "50%" }, 0);

        new ScrollMagic.Scene({
          triggerElement: this.$refs.container,
          triggerHook: "onEnter",
          duration: "200%"
        })
          .setTween(TweenMax.from(this.$refs.tablet, 1, { y: "50%" }, 0))
          .addTo(this.controller);

        // const mobileTl = new TimelineMax();
        // TweenMax.from(this.$refs.mobile, 2, { y: "-50%" }, 0);

        new ScrollMagic.Scene({
          triggerElement: this.$refs.container,
          triggerHook: "onEnter",
          duration: "200%"
        })
          .setTween(TweenMax.from(this.$refs.mobile, 2, { y: "-50%" }, 0))
          .addTo(this.controller);
      };

      const mobileAnimation = () => {
        const el = this.$refs.container;
        const { screen1, screen2, screen3 } = this.$refs;
        const screens = [screen1, screen2, screen3];
        const tl = new TimelineMax();
        screens.forEach(screen => {
          new ScrollMagic.Scene({
            triggerElement: screen,
            triggerHook: 0.6,
            reverse: false
          })
            .setTween(
              TweenMax.from(screen, 0.5, {
                y: 30,
                opacity: 0,
                ease: Cubic.easeInOut
              })
            )
            .addTo(this.controller);
        });
      };

      if (this.windowWidth < 768) {
        mobileAnimation();
      } else {
        desktopAnimation();
      }
    },
    resize(windowWidth) {
      this.$nextTick(() => {
        this.wrapperW = this.$refs.wrapper.offsetWidth;
        if (windowWidth >= 768) {
          TweenMax.set(this.$refs.container, {
            scale: this.wrapperW / this.wrapperMaxW,
            transformOrigin: "0 0"
          });
        } else {
          TweenMax.set(this.$refs.container, { clearProps: "all" });
        }
      });
    }
  },
  watch: {
    windowWidth: function(width) {
      this.resize(width);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resize(this.windowWidth);
      this.initScroll();
    });
  },
  beforeDestroy() {
    if (this.controller) {
      this.controller.destroy(true);
      this.controller = null;
    }
  }
};
</script>


<style lang="scss" scoped>
.devices {
  display: flex;
}
.device {
  position: relative;
  display: inline-block;
  flex: 0 0 auto;
  transform: translateZ(0);
}
.screen {
  position: relative;
  width: 100%;
}
.screen-content {
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

// Normal
@media (max-width: 767px) {
  .wrapper {
    margin: 5rem 0;
  }
  .devices {
    flex-wrap: wrap;
    justify-content: space-between;
    margin: -1rem;
  }
  .device {
    padding: 1rem;
  }
  .screen {
    box-shadow: 5px 5px 30px 0 rgba(black, 0.2);
  }
  .frame {
    display: none;
  }
  .desktop {
    flex: 0 0 100%;
    // margin-left: -25px;
    // flex: 0 0 calc(100% + 25px);
  }
  .tablet {
    flex: 0 0 66.666%;
  }

  .mobile {
    // flex: 0 0 33.333%;
    margin-right: -25px;
    flex: 0 0 calc(33.333% + 25px);
  }
}

// Perspective
@media (min-width: 768px) {
  // Aspect ratios
  .mobile {
    .screen {
      padding-bottom: 177.86%;
    }
  }
  .tablet {
    .screen {
      padding-bottom: 133.33%;
    }
  }
  .desktop {
    .screen {
      padding-bottom: 56.25%;
    }
  }

  .screen-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    transform-origin: 0% 0%;

    img {
      width: 100%;
      height: auto;
      transform: translateZ(0);
    }
  }

  .wrapper {
    width: 100%;
    position: relative;
    padding-bottom: 90.32%;
    height: 0;
    overflow: hidden;
  }
  .devices {
    position: absolute;
    top: 0;
    left: 0;
    width: 1240px;
    align-items: flex-end;
  }
  .frame {
    position: relative;
  }
  .screen {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 100%;
  }

  .mobile {
    margin-left: -17%;
    margin-bottom: 8%;

    .screen {
      padding-bottom: 177.86%;
    }
    .screen-content {
      transform: matrix3d(
        0.5786355705927764,
        0.038649525600143175,
        0,
        0.00027986807803797117,
        0.18944267213090862,
        0.7024205479008232,
        0,
        0.000011321608723516316,
        0,
        0,
        1,
        0,
        26,
        46,
        0,
        1
      );
    }
  }
  .tablet {
    margin-left: -22%;
    margin-bottom: 8.9%;
    // top: 36.5%;

    .screen {
      padding-bottom: 133.33%;
    }
    .screen-content {
      transform: matrix3d(
        0.3835588595718047,
        0.0473539902152229,
        0,
        -0.0002768011819560646,
        -0.27720501802261105,
        0.585617145597687,
        0,
        0.0000017314898920842036,
        0,
        0,
        1,
        0,
        222,
        32,
        0,
        1
      );
    }
  }
  .desktop {
    .screen {
      padding-bottom: 56.25%;
    }
    .screen-content {
      transform: matrix3d(
        1.16062304664386,
        0.36069549948223395,
        0,
        0.00038630877346944846,
        -0.024725616022098294,
        1.2001260715534883,
        0,
        -0.00017729816427005824,
        0,
        0,
        1,
        0,
        62,
        57,
        0,
        1
      );
    }
  }
}
</style>
